/** @jsxImportSource @emotion/react */
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { firstTableCellStyle } from "../../../style-util";

export const ChallengeListRowHeader = () => {
  return (
    <thead>
      <TableRowHeader>
        <TableCellHeaderText css={firstTableCellStyle}>
          Image
        </TableCellHeaderText>
        <TableCellHeaderText>Title</TableCellHeaderText>
        <TableCellHeaderText>Version</TableCellHeaderText>
        <TableCellHeaderText>People active on this?</TableCellHeaderText>
        <TableCellHeaderText>Allow new starts?</TableCellHeaderText>
        <TableCellHeaderText>Starts</TableCellHeaderText>
        <TableCellHeaderText>Ends</TableCellHeaderText>
        <TableCellHeaderText>Last reward claim date</TableCellHeaderText>
        <TableCellHeaderText>Auto claim</TableCellHeaderText>
      </TableRowHeader>
    </thead>
  );
};
